import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidMediaContentTypeError extends CodedError {
  static get errorName() {
    return errorCodes.invalidMediaContentTypeError.code;
  }

  constructor(message: string = errorCodes.invalidMediaContentTypeError.message) {
    super(message);
    this.code = errorCodes.invalidMediaContentTypeError.code;
    this.message = `${message} ${errorCodes.invalidMediaContentTypeError.code}`;
    this.name = errorCodes.invalidMediaContentTypeError.name;
  }
}
